import type { RouteRecordRaw } from 'vue-router'

const equipmentCertificatesRoutes: RouteRecordRaw[] = [
  {
    path: '/equipment-certificates',
    name: 'equipment-certificates.index',
    component: () =>
      import('@/modules/certificates/equipment-certificates/views/EquipmentCertificatesIndex.vue'),
    meta: {
      pageTitle: 'Equipment certificates',
      breadcrumbs: ['Equipment certificates']
    }
  },
  {
    path: '/equipment-certificates/:id',
    name: 'equipment-certificates.show',
    component: () =>
      import('@/modules/certificates/equipment-certificates/views/EquipmentCertificatesShow.vue'),
    meta: {
      pageTitle: 'Equipment certificates',
      breadcrumbs: ['Equipment certificates']
    }
  },
  {
    path: '/equipment-certificates/create',
    name: 'equipment-certificates.create',
    component: () =>
      import('@/modules/certificates/equipment-certificates/views/EquipmentCertificatesEdit.vue'),
    meta: {
      pageTitle: 'Equipment certificates',
      breadcrumbs: ['Equipment certificates']
    }
  },
  {
    path: '/equipment-certificates/:id/edit',
    name: 'equipment-certificates.edit',
    component: () =>
      import('@/modules/certificates/equipment-certificates/views/EquipmentCertificatesEdit.vue'),
    meta: {
      pageTitle: 'Equipment certificates',
      breadcrumbs: ['Equipment certificates']
    }
  }
]

export default equipmentCertificatesRoutes
